// @ is an alias to /src
// import { auth, firestore, db } from '@/firebase.js';
import { firebase } from '@/firebase.js';
// import _ from 'lodash';
// import icabody from '@/icabody.js'

const debug = false;
const name = 'store/modules/invites.js';

const state = {
  // invites: [],
  isUpdatingInvite: false,
}

const getters = {
  // getInvites (state) {
  //   return state.invites;
  // },
}

const mutations = {
  /**
   * setInvites mutation
   * @param projects Array of projects
   */
  // setInvites (state, invites) {
  //   if (debug) console.log(name, 'mutation setInvites() invites:', invites);
  //   state.invites = invites;
  // },

  /**
   * setUpdatingInvite mutation
   * @param value Boolean
   */
  setUpdatingInvite (state, value) {
    if (debug) console.log(name, 'mutation setUpdatingInvite() value:', value);
    state.isUpdatingInvite = value;
  },
}

// async function getInvitesFromDB() {
//   return new Promise((resolve) => {
//     db.collection('invites')
//     .where("to", "==", auth.currentUser.email)
//     .where("accepted", "==", false)
//     .get()
//     .then((querySnapshot) => {
//       if (debug) console.log(name,'getInvitesFromDB() querySnapshot:', querySnapshot);
//       resolve(querySnapshot);
//     })
//     .catch((error) => {
//       if (debug) console.log(name,'getInvitesFromDB() error:', error);
//       resolve(false);
//     });
//   })
// }

const actions = {
  /**
   * readInvites action
   * @returns Promise
   */
  // async readInvites ({ commit }) {
  //   // return new Promise((resolve, reject) => {
  //     if (debug) console.log(name,'action readInvites()');
  //     if (debug) console.log(name,'action readInvites() auth.currentUser:', auth.currentUser);
  //     if (debug) console.log(name,'action readInvites() auth.currentUser.email:', auth.currentUser.email);
  //     commit('setUpdatingInvite', true);
  //     const invites = [];

  //     let querySnapshot;
  //     do {
  //       if (debug) console.log(name,'readInvites() call getInvitesFromDB() ....');
  //       querySnapshot = await getInvitesFromDB();
  //       if (debug) console.log(name,'readInvites() querySnapshot:', querySnapshot);
  //     }
  //     while (querySnapshot === false);

  //     // db.collection('invites')
  //     // .where("to", "==", auth.currentUser.email)
  //     // .where("accepted", "==", false)
  //     // .get()
  //     // resultFromDB.then((querySnapshot) => {
  //     Promise.resolve().then(() => {
  //       if (debug) console.log(name,'action readInvites() querySnapshot:', querySnapshot);
  //       let promisesQueue = Promise.resolve();
  //       querySnapshot.forEach((document) => {
  //         const invite = document.data();
  //         if (debug) console.log(name,'action readInvites() invite:', invite);
  //         if (debug) console.log(name,'action readInvites() invite.projectId:', invite.projectId);
  //         promisesQueue = promisesQueue
  //         .then(() => {
  //           return db.collection('projects').doc(invite.projectId).get()
  //           .then((document) => {
  //             const project = document.data();
  //             if (debug) console.log(name,'action readInvites() project document data:', project);
  //             if (debug) console.log(name,'action readInvites() project title:', project.title);
  //             invite.project = project.title;
  //             return Promise.resolve();
  //           })
  //           .catch((error) => {
  //             if (debug) console.log(name,'action readInvites() read projectId', invite.projectId, ' error:', error);
  //             invite.project = invite.projectId;
  //             return Promise.resolve();
  //           });
  //         });
  //         invites.push(invite);
  //       });
  //       return promisesQueue;
  //     })
  //     .then(() => {
  //       if (debug) console.log(name,'action readInvites() invites:',invites);
  //       commit('setInvites', invites);
  //       commit('setUpdatingInvite', false);
  //       // resolve();
  //     })
  //     .catch((error) => {
  //       if (debug) console.log(name,'action readInvites() projects error:', error);
  //       commit('setUpdatingInvite', false);
  //       // reject(error.message);
  //     });
  //     // return resolve();
  //   // })
  // },

  /**
   * acceptInviteJoinProject action
   * @returns Promise
   */
  async acceptInviteJoinProject ({ commit }, invite) {
    if (debug) console.log(name,'action acceptInviteJoinProject()');
    if (debug) console.log(name,'action acceptInviteJoinProject() invite:', invite);
    commit('setUpdatingInvite', true);
    const acceptInvite = firebase.functions().httpsCallable('acceptInvite');
    try {
      const result = await acceptInvite(invite);
      if (debug) console.log(name,'action acceptInviteJoinProject() result:', result);
      // Remove invite from store
      // const invites = state.invites;
      // const foundIndex = invites.findIndex((element) => {
      //   return element.projectId === invite.projectId;
      // });
      // if (foundIndex >= 0) {
      //   const newInvites = _.cloneDeep(invites);
      //   if (debug) console.log(name,'action acceptInviteJoinProject() oldInvites:', newInvites);
      //   if (debug) console.log(name,'action acceptInviteJoinProject() foundIndex:', foundIndex);
      //   newInvites.splice(foundIndex, 1);
      //   if (debug) console.log(name,'action acceptInviteJoinProject() newInvites:', newInvites);
      //   commit('setInvites', newInvites);
      // }
      commit('setUpdatingInvite', false);
      return result.data;
      // resolve();
    }
    catch (error) {
      if (debug) console.log(name,'action acceptInviteJoinProject() error:', error);
      commit('setUpdatingInvite', false);
      // reject(error);
      throw error;
    }
  },

}

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
}